import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sp-user-settings',
  standalone: false,
  templateUrl: './user-settings.component.html',
  styleUrl: './user-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSettingsComponent {

}
